exports = module.exports = require("../../../node_modules/.0.28.5@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.example-appbar {\n  position: fixed;\n  left: 256px;\n  right: 0;\n  top: 0;\n  width: auto;\n  transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1);\n}\n.example-appbar.nav-hide {\n  left: 0;\n}\n.example-content {\n  padding-top: 54px;\n  padding-left: 256px;\n  transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1);\n}\n.example-content.nav-hide {\n  padding-left: 0;\n}\n@media (max-width: 750px) {\n.markdown-body {\n    padding: 20px;\n}\n.example-content {\n    padding-left: 0;\n}\n}\n.active {\n  color: red;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.0.28.5@css-loader!./node_modules/.13.0.4@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f796548","scoped":false,"hasInlineConfig":false}!./node_modules/.4.0.5@less-loader/dist/cjs.js?{"globalVars":{"museUiTheme":"'/Users/jiayihu/jiayi/projects/v-verify/node_modules/muse-ui/src/styles/themes/variables/green.less'"}}!./node_modules/.13.0.4@vue-loader/lib/selector.js?type=styles&index=0!./example/components/layout/layout.vue
// module id = 36
// module chunks = 5